import stickybits from 'stickybits';
import './index.sass';

export default ($root) => {
  stickybits('.js-sticky',{
    stickyBitStickyOffset: 20
  });

  function processResponse(data) {
    $('.comunity-list').find('.comunity-item').each(function () {
      $(this).remove();
    });
    var pagination = $('nav.pagination');
    $('.js-period-select').toggle(data.show_period)

    if (data.stub) {
      $('.comunity-list').append($(data.stub));
      pagination.html('');
      $('.js-period-select').toggle(false);
      return
    }
    $(data.posts).each(function () {
      var s = $(this);
      $('.comunity-list').append(s);
      s.hide().fadeIn(600);
    });

    pagination.html(data.page_section);
  }

  // $(document).on('ajax:success', 'a.js-sort-link', function (e, data) {
  //   $('a.js-sort-link').removeClass('switches__controls-link--active');
  //   $(this).addClass('switches__controls-link--active');
  //   processResponse(data);
  // });
  //
  // $('.drop-list a.js-sort-link').on('click', function () {
  //   var link = $(this).attr('href'),
  //       resp = $.get(link)
  //   resp.success(function (data) {
  //     processResponse(data)
  //   });
  //
  // });

  $root.find('.js-blog-show-more').on('click', e => {
    e.preventDefault();
    const $form = $root.find('.blog__form');
    const $list = $root.find('.js-list');
    const $pagination = $root.find('.js-pagination');
    $list.append('<div class="list-loader"></div>');
    let $page = $root.find('.js-input-hidden').val();

    $.ajax({
      url: `${$form.attr('action')}?page=${$page}`,
      data: $form.serialize(),
      type: "GET",
      success: function(res) {
        $list.append(res.posts)
        $list.find('.list-loader').remove();
        $pagination.html(res.page_section)
        $('.js-input-hidden').val(res.page + 1)
      },
      error: function(res) {
        console.log(res.status);
      }
    })
  })

  $('#posts_sort').on('change', function() {
    return $(this).closest('form').submit();
  });
  $('#posts_filter').on('change', function() {
    return $(this).closest('form').submit();
  });
  $('.js-disabled-add-post-btn').click(function() {
    showError(I18n.t('too_little_likes'));
    return false;
  });
  return $('.js-banned-add-post-btn').click(function() {
    showError(I18n.t('banned_by_admin'));
    return false;
  });
}
